/* import __COLOCATED_TEMPLATE__ from './clicked-list.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';

export default class ClickedList extends Component {
  get titleComponent() {
    return 'stats-system/list/tooltip-group/header/clicked-title';
  }
}
